import MainLayout from "../../layout/MainLayout";
import DataTable from "../../common/Tables/DataTable";
import { actionPost, useApiCall } from "../../services/api";
import useExpiredToken from "../../utils/useExpiredToken";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ShowData } from "../../utils/ShowData";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../utils/Toast";
import AuditType from "../../components/models/AuditType";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, qaTypeButtons, QA_ROLES, ADMIN_ROLES } from "../../constant";
import DateRangeFilter from "../../components/filters/DateRangeFilter";
import { EllipsisOutlined, EyeOutlined, PhoneOutlined, SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Dropdown, Space, Tag } from "antd";
import TextSearchFilter from "../../components/filters/TextSearchFilter";

const AssignedCallsByQL = () => {
  const [data, setData] = useState([]);
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const { callApi } = useApiCall();
  const role = useSelector((state) => state.auth.role);
  const { searchText } = useSelector((state) => state.search);
  const [deleteData, setDeleteData] = useState({});
  const navigate = useNavigate();
  const toast = useToast();
  const [isAudit, setIsAudit] = useState(false);
  const [auditType, setAuditType] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [qaList, setQAList] = useState([]);
  const [selectedQA, setSelectedQA] = useState(null);

  const handleCancel = () => {
    setIsAudit(false);
    setIsDetailsModalOpen(false);
  };

  // const fetchData = async () => {
  //   const res = await actionPost("calls/summary", token, "ASSIGNED_CALLS", {}, expireToken);
  //   const data = await processEncryptedResponse(res);
  //   if (data) {
  //     setData(data);
  //   }
  // };

  const handleAuditCall = (record) => {
    setDeleteData(record?.originalItem);
  };

  const fetchAllQA = async () => {
    const { decrypted, status } = await callApi({
      endpoint: "superadmin/users/qa/dynamic",
      queryParams: {
        qaId: selectedQA,
      },
      showToast: false,
    });

    if (status) {
      setQAList(decrypted?.users);
    }
  };

  // useEffect(() => {
  //   fetchAllQA();
  // }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [selectedQA]);

  const handleRedirect = (type) => {
    if (type == "back") {
      setIsAudit(false);
    } else {
      if (auditType) {
        navigate(`/audit-details/${deleteData?.id}`, {
          state: { record: deleteData, auditType },
        });
      } else {
        toast.error("Audit type not selected!");
      }
    }
  };

  // const auditTypeOptions =
  //   deleteData?.assigned_users?.audit_types
  //     ?.filter((item) => item?.status === false)
  //     ?.map((item) => ({
  //       label: item?.audit_type_name,
  //       value: item?.audit_type_id,
  //     })) || [];
  const auditTypeOptions =
    role === "qualitylead"
      ? deleteData?.assigned_users?.call_type === "assigned_to_ql"
        ? deleteData?.assigned_users?.audit_types
          ?.filter((item) => item?.status === false)
          ?.map((item) => ({
            label: item?.audit_type_name,
            value: item?.audit_type_id,
          })) || []
        : deleteData?.assigned_users?.audit_types
          ?.filter((item) => {
            if (item?.status === false) return true;
            if (item?.status === true && item?.ql_audit_status === false) return true;
            return false;
          })
          ?.map((item) => ({
            label: item?.audit_type_name,
            value: item?.audit_type_id,
          })) || []
      : deleteData?.assigned_users?.audit_types
        ?.filter((item) => item?.status === false)
        ?.map((item) => ({
          label: item?.audit_type_name,
          value: item?.audit_type_id,
        })) || [];

  useEffect(() => {
    if (!isAudit) return;
    // Auto-select ONLY if nothing is selected yet
    if (!auditType && auditTypeOptions?.length === 1) {
      setAuditType(auditTypeOptions[0].value);
    }
  }, [isAudit, auditTypeOptions, auditType]);
  const handleView = (record) => {
    setSelectedRow(record);
    setIsDetailsModalOpen(true);
  };

  const columns = [
    {
      title: "Call ID",
      dataIndex: "Call ID",
      key: "Call ID",
      width: 100,
    },
    {
      title: "Call date",
      dataIndex: "Call date",
      key: "Call date",
      width: 134,
      // filterDropdown: (props) => <DateRangeFilter {...props} />,
      // onFilter: (value, record) => {
      //   if (!value || value.length !== 2) return true;

      //   const [start, end] = value;
      //   const recordDate = dayjs(record["Call date"]);

      //   return recordDate.valueOf() >= start.valueOf() && recordDate.valueOf() <= end.valueOf();
      // },
    },
    {
      title: "Start time",
      dataIndex: "Start time",
      key: "Start time",
      width: 134,
    },
    {
      title: "End time",
      dataIndex: "End time",
      key: "End time",
      width: 134,
    },
    {
      title: "Agency name",
      dataIndex: "Agency name",
      key: "Agency name",
      width: 134,
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      width: 134,

      // filters: [
      //   { text: "Outgoing", value: "Outgoing" },
      //   { text: "Incoming", value: "Incoming" },
      // ],
      // onFilter: (value, record) => value && record["Call type"] === value,
    },
    {
      title: "Agent ID",
      dataIndex: "Agent ID",
      key: "Agent ID",
      width: 134,
      filterKey: "agent_id",
      filterDropdown: (props) => <TextSearchFilter {...props} placeholder="Search Agent Name" />,
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    },
    {
      title: "Agent name",
      dataIndex: ["originalItem", "agent_name"],
      key: "originalItem.agent_name",
      width: 134,
      filterKey: "agent_name",
      filterDropdown: (props) => <TextSearchFilter {...props} placeholder="Search Agent Name" />,
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    },
    {
      title: "Disconnected by",
      dataIndex: "Disconnected by",
      key: "Disconnected by",
      // filters: [
      //   { text: "Customer", value: "CUSTOMER" },
      //   { text: "Agent", value: "AGENT" },
      // ],
      // onFilter: (value, record) => value && record["Disconnected by"] === value,
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "Disposition",
      width: 350,
    },
    !QA_ROLES.includes(role) && {
      title: "Assigned QA",
      key: "assigned_users",
      render: (_, record) => {
        const users = record.assigned_users;
        return users && users.length > 0 ? (
          users.map((user) => (
            <Tag key={user.id} color="geekblue">
              {user.name} - ({user?.audit_types?.map((item) => item?.audit_type_name).join(", ")})
            </Tag>
          ))
        ) : (
          <span>-</span>
        );
      },
      // filters: qaList.map((item) => ({ text: item.full_name, value: item.id })),
      // onFilter: (value, record) => record?.assigned_users?.some((item) => item?.user_id === value),
    },
    {
      dataIndex: "assigned_users_text",
      key: "assigned_users_text",
      hidden: true,
    },
    {
      title: "Call status",
      dataIndex: "Call status",
      key: "Call status",
      render: (status) => <Tag color={status === "Connected" ? "green" : "red"}>{status}</Tag>,
      // filters: [
      //   { text: "Connected", value: "Connected" },
      //   { text: "Disconnected", value: "Disconnected" },
      // ],
      // onFilter: (value, record) => record["Call status"] === value,
    },
    {
      title: "Customer phone number",
      dataIndex: "Customer phone number",
      key: "Customer phone number",
    },
    QA_ROLES.includes(role) && {
      title: "Audit Types",
      key: "assigned_users",
      render: (_, record) => {
        const assignedUsers = record?.originalItem?.assigned_users;
        const auditTypes =
          role === "qualitylead"
            ? assignedUsers?.call_type === "assigned_to_ql"
              ? assignedUsers?.audit_types?.filter((item) => item?.status === false) || []
              : assignedUsers?.audit_types?.filter((item) => {
                if (item?.status === true) {
                  return item?.ql_audit_status === false;
                }
                return true;
              }) || []
            : assignedUsers?.audit_types?.filter((item) => item?.status === false) || [];

        return auditTypes && auditTypes.length > 0 ? (
          auditTypes.map((user) => (
            <Tag key={user.audit_type_id} color="geekblue">
              {user.audit_type_name}
            </Tag>
          ))
        ) : (
          <span>-</span>
        );
      },
      // filters: qaTypeButtons.map((item) => ({ text: item.label, value: item.id })),
      // onFilter: (value, record) =>
      //   record?.originalItem?.assigned_users?.audit_types
      //     ?.filter((item) => item?.status === false)
      //     ?.some((item) => item?.audit_type_id === value),
    },
    {
      title: "Action",
      key: "Action",
      render: (record) => {
        const assignedUsers = record?.originalItem?.assigned_users;
        const auditTypeOptions =
          role === "qualitylead"
            ? assignedUsers?.call_type === "assigned_to_ql"
              ? assignedUsers?.audit_types?.filter((item) => item?.status === false) || []
              : assignedUsers?.audit_types?.filter((item) => {
                if (item?.status === false) return true;
                if (item?.status === true && item?.ql_audit_status === false) return true;
                return false;
              }) || []
            : assignedUsers?.audit_types?.filter((item) => item?.status === false) || [];

        const menuItems = [
          ((QA_ROLES.includes(role) && auditTypeOptions?.length) || ADMIN_ROLES.includes(role)) && {
            key: "1",
            label: QA_ROLES.includes(role) ? "Audit Calls" : "View details",
            icon: QA_ROLES.includes(role) ? <PhoneOutlined /> : <EyeOutlined />,
            onClick: () => {
              if (QA_ROLES.includes(role)) {
                setIsAudit(true);
                handleAuditCall(record);
              } else {
                handleView(record);
              }
            },
          },
          QA_ROLES.includes(role) && {
            key: "2",
            label: "Call Details",
            icon: <EyeOutlined />,
            onClick: () => {
              handleView(record);
            },
          },
        ];

        return (
          <Dropdown
            menu={{
              items: menuItems,
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <EllipsisOutlined style={{ fontSize: 20 }} />
              </Space>
            </a>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <>
        <div className="container-fluid">
          {/* QA filter */}
          {/* <div className="pb-3 col-12 col-sm-3">
            <AppSelect
              label=""
              name="batch_number"
              type="text"
              placeholder="Select QA"
              options={qaList}
              value={selectedQA}
              rules={[{ required: true, message: "Please select the item!" }]}
              onChange={handleOnChange}
              allowClear
            />
          </div> */}
          <DataTable
            updatedColumns={columns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
                action: "ASSIGNED_CALLS_BY_QL",
                input: {},
              },
              apiMethod: "post",
            }}
          />
        </div>
      </>
      <AuditType
        handleCancel={handleCancel}
        open={isAudit}
        handleBack={handleRedirect}
        auditType={auditType}
        setAuditType={setAuditType}
        auditTypeOptions={auditTypeOptions}
      />

      <AssignedCallDetails
        open={isDetailsModalOpen}
        handleCancel={handleCancel}
        formData={selectedRow}
      />
    </>
  );
};

export default AssignedCallsByQL;
